import Authors from "./authors"
import { Icon } from "evergreen-ui"

export default class Banner extends Component {
  render() {
    const {
      title,
      subtitle,
      noFigure,
      figure,
      noAuthors = false,
      isHome = false,
      hasMarginBottom = true,
    } = this.props

    return (
      <React.Fragment>
        <Surface gridColumn={noFigure ? "text" : "page"} marginTop={40}>
          <Surface
            flexFlow="row"
            width={1024}
            justifyContent="space-between"
            alignSelf="center"
            alignItems="center"
            marginBottom={20}
          >
            <Surface>
              <Surface flexFlow="row" alignItems="center">
                {!isHome && (
                  <Text fontSize={30} fontWeight={700} opacity={0.7}>
                    <a
                      href="#/"
                      style={{
                        textDecoration: "none",
                        borderBottom: "0px solid black",
                      }}
                    >
                      Circuits
                    </a>
                  </Text>
                )}
                {!isHome && (
                  <Icon
                    icon="chevron-right"
                    marginX={10}
                    size={20}
                    marginTop={5}
                  />
                )}
                <Text fontSize={30} fontWeight={700}>
                  {title}
                </Text>
              </Surface>
              <Text
                fontSize={24}
                marginTop={20}
                fontWeight={400}
                width={isHome && 650}
                lineHeight={1.3}
              >
                {subtitle}
              </Text>
            </Surface>
          </Surface>
        </Surface>

        {figure}
        {!noAuthors && (
          <Authors hasMarginBottom={hasMarginBottom} hasBorderTop={!figure} />
        )}
      </React.Fragment>
    )
  }
}
